/**
 * Repeating on a fixed plan in the app (2026-10-14/15). The rules themselves are in planCore.ts
 * (an exact copy of the server's supabase/functions/_shared/planCore.ts); this adds the device's
 * local days, for the editor's summary and the calendar's "planned" entries. The server decides the
 * real next copy (Copenhagen days).
 */
import { isPlannedDay, parseSchedule, RepeatSchedule, withStart } from './planCore';

export type { RepeatSchedule };
export { parseSchedule, withStart };

/** 1 = Monday … 7 = Sunday. */
export const isoWeekday = (d: Date) => (d.getDay() === 0 ? 7 : d.getDay());

/** Local "YYYY-MM-DD". */
export const ymd = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const isPlanned = (s: RepeatSchedule, day: Date) => isPlannedDay(s, day.getFullYear(), day.getMonth() + 1, day.getDate());

/** Start of the next planned day: from `after`'s day if `includeToday`, else from the day after. */
export function nextPlannedDay(s: RepeatSchedule, after: Date, includeToday: boolean): Date | null {
  for (let k = includeToday ? 0 : 1; k <= 400; k++) {
    const d = new Date(after.getFullYear(), after.getMonth(), after.getDate() + k);
    if (isPlanned(s, d)) return d;
  }
  return null;
}
